import { render, staticRenderFns } from "./column-header.vue?vue&type=template&id=5215e754"
import script from "./column-header.vue?vue&type=script&lang=js"
export * from "./column-header.vue?vue&type=script&lang=js"
import style0 from "./column-header.vue?vue&type=style&index=0&id=5215e754&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports